import { Alert, Typography } from 'antd';
import React from 'react';
import IntlMessages from '../../../../../util/IntlMessages';
import moment from 'moment';

const isExpired = (pixData) => {
    return moment().isAfter(moment(pixData.created_at).add(pixData.expiration, 'seconds'));
}

const PixContent = ({ pixData }) => {

    if(!pixData || !pixData.qr_code) {
        return (
            <div>
                <Alert message={<IntlMessages id='common.payment_not_found' />} type="error" showIcon />
            </div>
        )
    }

    if (isExpired(pixData)) {
        return (
            <div>
                <Alert message={<IntlMessages id='common.pix_payment_expired' />} type="error" showIcon />
            </div>
        )
    }

    if (pixData.status === 'CONCLUIDA') {

        return (
            <div>
                <Alert message={<IntlMessages id="payments.success" />} type="success" showIcon />
            </div>
        )

    }

    return (
        <div>
            <p><strong>QR Code:</strong></p>
            {pixData.qr_code_base64 && (
                <div>
                    <img alt="PIX QR Code" src={pixData.qr_code_base64} style={{ maxWidth: '100%', height: 'auto' }} />
                </div>
            )}
            {pixData.qr_code && (
                <div className='gx-mt-3'>
                    <p><strong>{<IntlMessages id='common.code' />}:</strong></p>
                    <div style={{ wordBreak: 'break-all', background: '#f4f4f4', padding: 10, borderRadius: 5 }}>
                        <Typography.Text copyable>{pixData.qr_code}</Typography.Text>
                    </div>
                </div>
            )}
        </div>
    )
}

export default PixContent;